import React, { useState } from 'react';

import './EmptyFieldWarning.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faInfo } from '@fortawesome/free-solid-svg-icons';

export function EmptyFieldWarning({
  message = 'Não existem dados para exibir',
}) {
  const [visible, setVisible] = useState(true);
  return (
    <>
      {visible && (
        <div className="warningContainer">
          <div className="warningContainer-content">
            <div className="wargningMessage">
              <div className="warningContainer-icon">
                <FontAwesomeIcon icon={faInfo} />
              </div>
              <p>{message}</p>
            </div>
            <button onClick={() => setVisible(false)}>
              <FontAwesomeIcon className="warningIcon-close" icon={faClose} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
